import { render, staticRenderFns } from "./banner5.vue?vue&type=template&id=3748562d&scoped=true&"
import script from "./banner5.vue?vue&type=script&lang=js&"
export * from "./banner5.vue?vue&type=script&lang=js&"
import style0 from "./banner5.vue?vue&type=style&index=0&id=3748562d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748562d",
  null
  
)

export default component.exports